module.exports = __webpack_public_path__ + "img/zhan1.33b109c1.png";